// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__90UBT","label":"styles_label__9enMJ","tagList":"styles_tagList__ukRTv","tag":"styles_tag__gVoDD"};